export enum RouteNames {
  ASSISTANT_PAGE = 'assistant_page',
}

export const ProductManageList = [
  'ProductManageView',
  'CreateProductView',
  'ProductDetailMainView',
  'ProductDetailView',
  'ProposalDetailView',
  'ProductInformationView',
  'ProductIntelligenceView',
  'ProductDynamicView',
]

export const CustomerProposalList = [
  'CustomerProposal',
  'CustomerProposalDetail',
]
